module.exports = __webpack_public_path__ + "media/images/Sura-3bd75955.png";